import React from "react";
import { useDatadogAwsConsolelogin } from "@/hooks/useDatadogAwsConsole";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import DatadogDashboard from "@/components/organisms/DatadogAwsConsoleDashboard";

function DatadogAWSConsoleReports() {
  const { embedUrl, loading, error, refetch } = useDatadogAwsConsolelogin();

  return (
    <AWSReportsTemplate
      title="Datadog Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <DatadogDashboard/>
    </AWSReportsTemplate>
  );
}

export default DatadogAWSConsoleReports;